module.exports = __webpack_public_path__ + "img/jianhang.08c42ceb.png";